import { CalenderDateListDto, FlexDateDto, ICalendar, ICalendarDictionary } from "./types";

export function convert(calendar: ICalendar): CalenderDateListDto | undefined {

    if (!calendar)
        return undefined;


    const dates = calendar.dates ? Object.values(calendar.dates)?.map((value: string) => JSON.parse(value)) : [];
    const dateRanges = calendar.dateRanges ? Object.values(calendar.dateRanges)?.map((value: string) => JSON.parse(value)) : [];
    const wnds = calendar.weekNDays ? Object.values(calendar.weekNDays)?.map((value: string) => JSON.parse(value)) : [];

    const ret: CalenderDateListDto = { dates: dates, dateRanges: dateRanges, weekNDays: wnds };
    return ret;
}

export function convertBack(obj: CalenderDateListDto | undefined): { dates: ICalendarDictionary, dateRanges: ICalendarDictionary, weekNDays: ICalendarDictionary } {
    if (!obj)
        return { dates: {}, dateRanges: {}, weekNDays: {} };

        const datesMod = obj.dates?.slice().filter((val: FlexDateDto) => val.day)
    var i = 0;
    const dates = obj.dates ? Object.assign({}, ...obj.dates.map((value) => ({ [String(i++)]: JSON.stringify(value) }))) : {};
    i = 0;
    const dateRanges = obj.dateRanges ? Object.assign({}, ...obj.dateRanges.map((value) => ({ [String(i++)]: JSON.stringify(value) }))) : {};
    i = 0;
    const wnds = obj.weekNDays ? Object.assign({}, ...obj.weekNDays.map((value) => ({ [String(i++)]: JSON.stringify(value) }))) : {};

    return { dates: dates, dateRanges: dateRanges, weekNDays: wnds };
}